import { collection, addDoc, query, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import type { AuditEntry } from '../utils';

export const AuditService = {
    /** Subscribe to audit trail updates */
    subscribeToAuditTrail(projectId: string, callback: (entries: AuditEntry[]) => void): () => void {
        const q = query(collection(db, 'projects', projectId, 'audit_trail'), orderBy('timestamp', 'desc'));
        return onSnapshot(q, (snapshot) => {
            callback(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })) as AuditEntry[]);
        });
    },

    /** Add a new audit entry to the subcollection */
    async addAuditEntry(projectId: string, entry: Omit<AuditEntry, 'id'>): Promise<string> {
        // Firestore rejects undefined values
        const cleanEntry = Object.fromEntries(Object.entries(entry).filter(([, value]) => value !== undefined));
        const docRef = await addDoc(collection(db, 'projects', projectId, 'audit_trail'), cleanEntry);
        return docRef.id;
    }
};
